import NaptimeResource from './NaptimeResource';

class EnterpriseSentMessages extends NaptimeResource {
  static RESOURCE_NAME = 'enterpriseSentMessages.v1';
}

export default EnterpriseSentMessages;
